import * as React from "react";

export const AgentTemplateNotSelected = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    fill="none"
    viewBox="0 0 24 24"
  >
    <g clipPath="url(#clip0_77_47)">
      <g clipPath="url(#clip1_77_47)">
        <path fill="#fff" d="M0 0h24v24H0z"></path>
        <path
          fill="#9A9FA5"
          fillRule="evenodd"
          d="M22.5 20.25a2.25 2.25 0 0 1-2.25 2.25H3.75a2.25 2.25 0 0 1-2.25-2.25V7.5h21v12.75M22.5 6h-21V3.75A2.25 2.25 0 0 1 3.75 1.5h16.5a2.25 2.25 0 0 1 2.25 2.25zm-3.75-2.25a.75.75 0 1 1 1.5 0 .75.75 0 0 1-1.5 0m-2.25 0a.75.75 0 1 1 1.5 0 .75.75 0 0 1-1.5 0m-2.25 0a.75.75 0 1 1 1.5 0 .75.75 0 0 1-1.5 0M10.11 16.5c.337.305.627.669.854 1.08a.29.29 0 0 1-.097.383.26.26 0 0 1-.134.037H4.267a.26.26 0 0 1-.134-.038.3.3 0 0 1-.097-.102.29.29 0 0 1 0-.28c.227-.411.517-.775.854-1.08.402-.362.87-.641 1.383-.815a2.5 2.5 0 0 1-.999-1.224 2.64 2.64 0 0 1-.088-1.61c.14-.532.441-1 .86-1.335A2.33 2.33 0 0 1 7.5 11c.526 0 1.037.181 1.455.516.418.334.72.803.859 1.336.14.532.108 1.097-.088 1.609a2.5 2.5 0 0 1-.999 1.224c.512.174.981.453 1.383.815"
          clipRule="evenodd"
        ></path>
        <path fill="#fff" d="M14 12h6v2h-6zM14 15h6v2h-6z"></path>
      </g>
    </g>
    <defs>
      <clipPath id="clip0_77_47">
        <path fill="#fff" d="M0 0h24v24H0z"></path>
      </clipPath>
      <clipPath id="clip1_77_47">
        <path fill="#fff" d="M0 0h24v24H0z"></path>
      </clipPath>
    </defs>
  </svg>
);

export const AgentTemplateSelected = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    fill="none"
    viewBox="0 0 24 24"
  >
    <g clipPath="url(#clip0_72_4)">
      <g clipPath="url(#clip1_72_4)">
        <path fill="#fff" d="M0 0h24v24H0z"></path>
        <path
          fill="#000"
          fillRule="evenodd"
          d="M22.5 20.25a2.25 2.25 0 0 1-2.25 2.25H3.75a2.25 2.25 0 0 1-2.25-2.25V7.5h21v12.75M22.5 6h-21V3.75A2.25 2.25 0 0 1 3.75 1.5h16.5a2.25 2.25 0 0 1 2.25 2.25zm-3.75-2.25a.75.75 0 1 1 1.5 0 .75.75 0 0 1-1.5 0m-2.25 0a.75.75 0 1 1 1.5 0 .75.75 0 0 1-1.5 0m-2.25 0a.75.75 0 1 1 1.5 0 .75.75 0 0 1-1.5 0M10.11 16.5c.337.305.627.669.854 1.08a.29.29 0 0 1-.097.383.26.26 0 0 1-.134.037H4.267a.26.26 0 0 1-.134-.038.3.3 0 0 1-.097-.102.29.29 0 0 1 0-.28c.227-.411.517-.775.854-1.08.402-.362.87-.641 1.383-.815a2.5 2.5 0 0 1-.999-1.224 2.64 2.64 0 0 1-.088-1.61c.14-.532.441-1 .86-1.335A2.33 2.33 0 0 1 7.5 11c.526 0 1.037.181 1.455.516.418.334.72.803.859 1.336.14.532.108 1.097-.088 1.609a2.5 2.5 0 0 1-.999 1.224c.512.174.981.453 1.383.815"
          clipRule="evenodd"
        ></path>
        <path fill="#fff" d="M14 12h6v2h-6zM14 15h6v2h-6z"></path>
      </g>
    </g>
    <defs>
      <clipPath id="clip0_72_4">
        <path fill="#fff" d="M0 0h24v24H0z"></path>
      </clipPath>
      <clipPath id="clip1_72_4">
        <path fill="#fff" d="M0 0h24v24H0z"></path>
      </clipPath>
    </defs>
  </svg>
);


export const TemplateNotSelected = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    fill="none"
    viewBox="0 0 24 24"
  >
    <path fill="#9A9FA5" d="M2 2h9v9H2zM17 2l5 9h-9z"></path>
    <rect width="9" height="9" x="2" y="13" fill="#9A9FA5" rx="4.5"></rect>
    <path fill="#9A9FA5" d="M13 13h9v9h-9z"></path>
  </svg>
);

export const TemplateSelected = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    fill="none"
    viewBox="0 0 24 24"
  >
    <path fill="#000" d="M2 2h9v9H2zM17 2l5 9h-9z"></path>
    <rect width="9" height="9" x="2" y="13" fill="#000" rx="4.5"></rect>
    <path fill="#000" d="M13 13h9v9h-9z"></path>
  </svg>
);

export const UserNotSelected = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    fill="none"
    viewBox="0 0 24 24"
  >
    <g clipPath="url(#clip0_77_56)">
      <g clipPath="url(#clip1_77_56)">
        <path
          fill="#9A9FA5"
          d="M21.744 19.874a11.3 11.3 0 0 0-6.292-5.076 6.75 6.75 0 1 0-6.904 0 11.3 11.3 0 0 0-6.292 5.076.75.75 0 0 0 .65 1.125h18.189a.75.75 0 0 0 .65-1.125"
        ></path>
      </g>
    </g>
    <defs>
      <clipPath id="clip0_77_56">
        <path fill="#fff" d="M0 0h24v24H0z"></path>
      </clipPath>
      <clipPath id="clip1_77_56">
        <path fill="#fff" d="M0 0h24v24H0z"></path>
      </clipPath>
    </defs>
  </svg>
);

export const UserSelected = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    fill="none"
    viewBox="0 0 24 24"
  >
    <g clipPath="url(#clip0_72_5)">
      <g clipPath="url(#clip1_72_5)">
        <path
          fill="#000"
          d="M21.744 19.874a11.3 11.3 0 0 0-6.292-5.076 6.75 6.75 0 1 0-6.904 0 11.3 11.3 0 0 0-6.292 5.076.75.75 0 0 0 .65 1.125h18.189a.75.75 0 0 0 .65-1.125"
        ></path>
      </g>
    </g>
    <defs>
      <clipPath id="clip0_72_5">
        <path fill="#fff" d="M0 0h24v24H0z"></path>
      </clipPath>
      <clipPath id="clip1_72_5">
        <path fill="#fff" d="M0 0h24v24H0z"></path>
      </clipPath>
    </defs>
  </svg>
);

export const LogNotSelected = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    fill="none"
    viewBox="0 0 24 24"
  >
    <g clipPath="url(#clip0_77_60)">
      <g clipPath="url(#clip1_77_60)">
        <path
          fill="#9A9FA5"
          d="M12.992 8.06c.65.69 1.108 1.489 1.397 2.331l7.228.216 1.331 1.414s.487 2.21-.553 3.19l-1.885 1.774-1.776-1.884-1.885 1.775-1.775-1.885-2.356 2.219a6.47 6.47 0 0 1-9.15-.274 6.47 6.47 0 0 1 .274-9.15 6.47 6.47 0 0 1 9.15.273m-2.937 6.323a2.589 2.589 0 0 0-1.7-4.474 2.59 2.59 0 1 0 1.7 4.474"
        ></path>
      </g>
    </g>
    <defs>
      <clipPath id="clip0_77_60">
        <path fill="#fff" d="M0 0h24v24H0z"></path>
      </clipPath>
      <clipPath id="clip1_77_60">
        <path fill="#fff" d="M0 0h24v24H0z"></path>
      </clipPath>
    </defs>
  </svg>
);

export const LogSelected = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    fill="none"
    viewBox="0 0 24 24"
  >
    <g clipPath="url(#clip0_72_6)">
      <g clipPath="url(#clip1_72_6)">
        <path
          fill="#000"
          d="M12.992 8.06c.65.69 1.108 1.489 1.397 2.331l7.228.216 1.331 1.414s.487 2.21-.553 3.19l-1.885 1.774-1.776-1.884-1.885 1.775-1.775-1.885-2.356 2.219a6.47 6.47 0 0 1-9.15-.274 6.47 6.47 0 0 1 .274-9.15 6.47 6.47 0 0 1 9.15.273m-2.937 6.323a2.589 2.589 0 0 0-1.7-4.474 2.59 2.59 0 1 0 1.7 4.474"
        ></path>
      </g>
    </g>
    <defs>
      <clipPath id="clip0_72_6">
        <path fill="#fff" d="M0 0h24v24H0z"></path>
      </clipPath>
      <clipPath id="clip1_72_6">
        <path fill="#fff" d="M0 0h24v24H0z"></path>
      </clipPath>
    </defs>
  </svg>
);

export const MappingNotSelected = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    fill="none"
    viewBox="0 0 24 24"
  >
    <path stroke="#9A9FA5" strokeWidth="2" d="m12 5.5-6 12h12z"></path>
    <circle cx="12" cy="5" r="4" fill="#9A9FA5"></circle>
    <circle cx="5" cy="18" r="4" fill="#9A9FA5"></circle>
    <circle cx="19" cy="18" r="4" fill="#9A9FA5"></circle>
  </svg>
);

export const MappingSelected = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    fill="none"
    viewBox="0 0 24 24"
  >
    <path stroke="#000" strokeWidth="2" d="m12 5.5-6 12h12z"></path>
    <circle cx="12" cy="5" r="4" fill="#000"></circle>
    <circle cx="5" cy="18" r="4" fill="#000"></circle>
    <circle cx="19" cy="18" r="4" fill="#000"></circle>
  </svg>
);

export const JourneyNotSelected = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    fill="none"
    viewBox="0 0 24 24"
  >
    <path
      fill="#9A9FA5"
      d="M19.394 11.566h2.372c1.193 0 1.69-1.528.724-2.229l-9.765-7.101a1.23 1.23 0 0 0-1.45 0l-9.765 7.1c-.965.702-.469 2.23.724 2.23h2.372v8.625a1.23 1.23 0 0 0 1.233 1.232h3.696V14.03h4.93v7.393h3.696a1.23 1.23 0 0 0 1.233-1.232z"
    ></path>
  </svg>
);

export const JourneySelected = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    fill="none"
    viewBox="0 0 24 24"
  >
    <path
      fill="#000"
      d="M19.394 11.566h2.372c1.193 0 1.69-1.528.724-2.229l-9.765-7.101a1.23 1.23 0 0 0-1.45 0l-9.765 7.1c-.965.702-.469 2.23.724 2.23h2.372v8.625a1.23 1.23 0 0 0 1.233 1.232h3.696V14.03h4.93v7.393h3.696a1.23 1.23 0 0 0 1.233-1.232z"
    ></path>
  </svg>
);

export const QnaSelected = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    fill="none"
    viewBox="0 0 24 24"
  >
    {/* Question bubble */}
    <rect
      x="2"
      y="3"
      width="14"
      height="9"
      rx="2"
      fill="#000"
    />
    <path
      d="M6 12L5 15L9 12"
      fill="#000"
    />

    {/* Answer bubble */}
    <rect
      x="8"
      y="13"
      width="14"
      height="8"
      rx="2"
      fill="#000"
    />
    <path
      d="M16 13L18 10L14 13"
      fill="#000"
    />

    {/* Q mark */}
    <text
      x="7"
      y="10"
      fontSize="6"
      fontWeight="bold"
      fill="#fff"
      fontFamily="Arial, sans-serif"
    >
      Q
    </text>

    {/* A mark */}
    <text
      x="13"
      y="19"
      fontSize="6"
      fontWeight="bold"
      fill="#fff"
      fontFamily="Arial, sans-serif"
    >
      A
    </text>
  </svg>
);

export const QnaNotSelected = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    fill="none"
    viewBox="0 0 24 24"
  >
    {/* Question bubble */}
    <rect
      x="2"
      y="3"
      width="14"
      height="9"
      rx="2"
      fill="#9A9FA5"
    />
    <path
      d="M6 12L5 15L9 12"
      fill="#9A9FA5"
    />

    {/* Answer bubble */}
    <rect
      x="8"
      y="13"
      width="14"
      height="8"
      rx="2"
      fill="#9A9FA5"
    />
    <path
      d="M16 13L18 10L14 13"
      fill="#9A9FA5"
    />

    {/* Q */}
    <text
      x="7"
      y="10"
      fontSize="6"
      fontWeight="bold"
      fill="#fff"
      fontFamily="Arial, sans-serif"
    >
      Q
    </text>

    {/* A */}
    <text
      x="13"
      y="19"
      fontSize="6"
      fontWeight="bold"
      fill="#fff"
      fontFamily="Arial, sans-serif"
    >
      A
    </text>
  </svg>
);

export const FunctionSelected = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-gear" viewBox="0 0 16 16">  <path d="M8 4.754a3.246 3.246 0 1 0 0 6.492 3.246 3.246 0 0 0 0-6.492M5.754 8a2.246 2.246 0 1 1 4.492 0 2.246 2.246 0 0 1-4.492 0" />  <path d="M9.796 1.343c-.527-1.79-3.065-1.79-3.592 0l-.094.319a.873.873 0 0 1-1.255.52l-.292-.16c-1.64-.892-3.433.902-2.54 2.541l.159.292a.873.873 0 0 1-.52 1.255l-.319.094c-1.79.527-1.79 3.065 0 3.592l.319.094a.873.873 0 0 1 .52 1.255l-.16.292c-.892 1.64.901 3.434 2.541 2.54l.292-.159a.873.873 0 0 1 1.255.52l.094.319c.527 1.79 3.065 1.79 3.592 0l.094-.319a.873.873 0 0 1 1.255-.52l.292.16c1.64.893 3.434-.902 2.54-2.541l-.159-.292a.873.873 0 0 1 .52-1.255l.319-.094c1.79-.527 1.79-3.065 0-3.592l-.319-.094a.873.873 0 0 1-.52-1.255l.16-.292c.893-1.64-.902-3.433-2.541-2.54l-.292.159a.873.873 0 0 1-1.255-.52zm-2.633.283c.246-.835 1.428-.835 1.674 0l.094.319a1.873 1.873 0 0 0 2.693 1.115l.291-.16c.764-.415 1.6.42 1.184 1.185l-.159.292a1.873 1.873 0 0 0 1.116 2.692l.318.094c.835.246.835 1.428 0 1.674l-.319.094a1.873 1.873 0 0 0-1.115 2.693l.16.291c.415.764-.42 1.6-1.185 1.184l-.291-.159a1.873 1.873 0 0 0-2.693 1.116l-.094.318c-.246.835-1.428.835-1.674 0l-.094-.319a1.873 1.873 0 0 0-2.692-1.115l-.292.16c-.764.415-1.6-.42-1.184-1.185l.159-.291A1.873 1.873 0 0 0 1.945 8.93l-.319-.094c-.835-.246-.835-1.428 0-1.674l.319-.094A1.873 1.873 0 0 0 3.06 4.377l-.16-.292c-.415-.764.42-1.6 1.185-1.184l.292.159a1.873 1.873 0 0 0 2.692-1.115z" /></svg>
);

export const FuntionNotSelected = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-gear-fill" viewBox="0 0 16 16">  <path d="M9.405 1.05c-.413-1.4-2.397-1.4-2.81 0l-.1.34a1.464 1.464 0 0 1-2.105.872l-.31-.17c-1.283-.698-2.686.705-1.987 1.987l.169.311c.446.82.023 1.841-.872 2.105l-.34.1c-1.4.413-1.4 2.397 0 2.81l.34.1a1.464 1.464 0 0 1 .872 2.105l-.17.31c-.698 1.283.705 2.686 1.987 1.987l.311-.169a1.464 1.464 0 0 1 2.105.872l.1.34c.413 1.4 2.397 1.4 2.81 0l.1-.34a1.464 1.464 0 0 1 2.105-.872l.31.17c1.283.698 2.686-.705 1.987-1.987l-.169-.311a1.464 1.464 0 0 1 .872-2.105l.34-.1c1.4-.413 1.4-2.397 0-2.81l-.34-.1a1.464 1.464 0 0 1-.872-2.105l.17-.31c.698-1.283-.705-2.686-1.987-1.987l-.311.169a1.464 1.464 0 0 1-2.105-.872zM8 10.93a2.929 2.929 0 1 1 0-5.86 2.929 2.929 0 0 1 0 5.858z" /></svg>
);



export const MonitoringSelected = (props) => (
  <svg viewBox="0 -5 20 20" xmlns="http://w3.org" fill="none" {...props}>
    <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
    <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
    <g id="SVGRepo_iconCarrier">
      <path
        id="primary"
        d="M21,12H17l-2,4L11,8,8,15,6,12H3"
        transform="translate(-2 -7)"
        fill="none"
        stroke="#000000"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      ></path>
    </g>
  </svg>
);

export const MonitoringNotSelected = (props) => (

  <svg viewBox="0 -5 20 20" xmlns="http://w3.org" fill="none" {...props}>
    <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
    <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
    <g id="SVGRepo_iconCarrier">
      <path
        id="primary"
        d="M21,12H17l-2,4L11,8,8,15,6,12H3"
        transform="translate(-2 -7)"
        fill="none"
        stroke="#000000"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="3"
      ></path>
    </g>
  </svg>
);

// Shield with a face outline: face verification settings.
const VerificationSettingsIcon = ({ color }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    fill="none"
    viewBox="0 0 24 24"
  >
    <path
      fill={color}
      fillRule="evenodd"
      d="M12 1.5 3.5 4.75v6.1c0 5.2 3.6 10.05 8.5 11.65 4.9-1.6 8.5-6.45 8.5-11.65v-6.1zm0 5a2.75 2.75 0 1 0 0 5.5 2.75 2.75 0 0 0 0-5.5m-4.75 9.6c.95-1.6 2.75-2.6 4.75-2.6s3.8 1 4.75 2.6A7.6 7.6 0 0 1 12 19.4a7.6 7.6 0 0 1-4.75-3.3"
      clipRule="evenodd"
    ></path>
  </svg>
);

export const VerificationSettingsNotSelected = (props) => (
  <VerificationSettingsIcon color="#9A9FA5" />
);

export const VerificationSettingsSelected = (props) => (
  <VerificationSettingsIcon color="#000" />
);
